import React from "react"
import { Box, VStack } from "@chakra-ui/react"
import { useParams } from "react-router"
import { useBadgeSelection } from "../../contexts/BadgeSelectionContext"
import BadgeSidePanelForm from "./BadgeSidePanelForm"
import ElementSpecificFields from "./ElementSpecificFields"
import BadgeGeneralPanel from "./BadgeGeneralPanel"
import BadgeGroupPanel from "./BadgeGroupPanel"
import CommonStylingFields from "./Fields/CommonStylingFields"
import { elementToFormValues } from "../../utils/elementTransformers"

/**
 * EditorPanel
 *
 * Panel content for the editor panel (right panel).
 * Shows general panel when no/multiple elements selected,
 * or element-specific editor when one element is selected.
 */
const EditorPanel = () => {
  const { selectedElements } = useBadgeSelection()
  const { eventId } = useParams<{ eventId: string }>()

  // The badge's settings with nothing selected, what several elements share for a group
  if (selectedElements.length === 0) return <BadgeGeneralPanel />
  if (selectedElements.length > 1) return <BadgeGroupPanel elements={selectedElements} />

  // Show element-specific panel when exactly one element is selected
  const selectedElement = selectedElements[0]
  const { type } = selectedElement

  // Convert element to form values using centralized transformer
  const formValues = elementToFormValues(selectedElement)

  return (
    <Box py={2}>
      <BadgeSidePanelForm
        key={selectedElement.id}
        initialValues={formValues}
        selectedElementId={selectedElement.id}
      >
        {({ control }) => (
          <VStack spacing={6} align="stretch">
            <CommonStylingFields control={control} elementType={type} />

            <ElementSpecificFields
              control={control}
              eventId={eventId}
            />
          </VStack>
        )}
      </BadgeSidePanelForm>
    </Box>
  )
}

export default EditorPanel
